import React from 'react';
import { Box } from '@mui/material';
import { flexGap2 } from '../../../../constants/lkCadastr/cadastrStorage';
import { TextTitle } from '../../../../components/Text';
import { ClearButton, DownloadButton, ReportCounter } from './common';

export function ReportTemplate({
  reportTitle,
  clear,
  visibleClear,
  children,
  error,
  downloadOptions,
  counterOptions,
}) {
  const { disableDownload, makeRequest } = downloadOptions ?? {};
  const { countReports, counterTitle, loadingCountReports } = counterOptions ?? {};

  return (
    <>
      <Box sx={flexGap2}>
        <TextTitle>{reportTitle}</TextTitle>
        {visibleClear && <ClearButton onClick={clear} />}
        {error && <TextTitle sx={{ color: 'red', mt: 1 }}>{error}</TextTitle>}
        {children}
      </Box>

      {downloadOptions && <DownloadButton disabled={disableDownload || error} onClick={() => makeRequest()} />}
      {counterOptions && (
      <ReportCounter loading={loadingCountReports} title={counterTitle}>
        {countReports}
      </ReportCounter>
      )}
    </>
  );
}
